import { Button } from "~/components";

import iphone_img from "/img/iphone.png";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

const PerfectMatch = () => {
  const width = useWindowWidth();
  return (
    <section
      className="max-md:pt-8 max-md:pb-12 py-[120px] bg-[url('/img/perfect-match.png')] bg-no-repeat bg-cover bg-center"
      id="perfect"
    >
      <div className="container">
        <div className="max-md:grid-cols-1 grid grid-cols-2">
          <div className="max-md:w-full max-w-full w-[349px]">
            <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-5xl font-extrabold leading-[60px]">
              Find Your Perfect Match in no time
            </h2>

            <p className="max-lg:mt-4 max-lg:mb-8 max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light font tracking-tight mt-4 mb-12">
              Explore by genre, tropes, spice level to find your new favorites.
            </p>

            {width > 767 && (
              <div className="flex justify-center">
                <Button className="max-md:w-full max-md:px-0 px-24" />
              </div>
            )}
          </div>
          <div className="flex justify-center">
            <img className="max-w-[306px]" src={iphone_img} alt="Iphone" />
          </div>
          {width < 768 && (
            <div className="flex justify-center max-md:mt-12">
              <Button className="max-md:w-full max-md:px-0 px-24" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

PerfectMatch.disolayName = "PerfectMatch";
export default PerfectMatch;
